module.exports = __webpack_public_path__ + "static/media/wireframe.96a7dd7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/wireframe.gif
// module id = 192
// module chunks = 0